export default function SecuritySettings() {
  return (
    <div>
      <h2>Security</h2>

      <div style={styles.card}>
        Security settings coming soon
      </div>
    </div>
  );
}

const styles = {
  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    marginTop: "15px",
  },
};
